var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-layout"},[_c('TopNavbar'),_c('div',{staticClass:"container-fluid px-0"},[_c('b-row',[_c('b-col',{attrs:{"lg":"2"}},[_c('SideMenu')],1),_c('b-col',{staticClass:"view-section-dimensions",attrs:{"lg":"10"}},[_vm._t("default")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }